import React, { Component } from 'react';


class MainHeader extends Component{
	constructor(props){
		super(props);
		this.addBlankLine=this.addBlankLine.bind(this);
	}
	addBlankLine()
	{
		return {__html:'<br>'};
	}
	render()
	{
		return (
		<div id="_MainHeader">
	   <img class='logo' src='LOGO2.jpg'/>
	    </div>	   
	   );
	   
	}
}

export default MainHeader;